import { render, staticRenderFns } from "./Destinatario.vue?vue&type=template&id=483d5b5a&"
import script from "./Destinatario.vue?vue&type=script&lang=js&"
export * from "./Destinatario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports